export default __webpack_public_path__ + "static/custom_config_01-9d3bff6f23c3ab8afcb870912e91c215.png";